// src/components/Routes/StudentFaturaRoute.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { CircularProgress, Box, Alert } from '@mui/material';

const StudentFaturaRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { prestacaoId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Se estiver carregando, aguarde
    if (loading) return;

    // Se não houver usuário autenticado
    if (!user) {
      const returnPath = `/estudante/prestacoes/${prestacaoId}`;
      const loginUrl = `/login?returnTo=${encodeURIComponent(returnPath)}`;
      navigate(loginUrl, { replace: true });
      return;
    }

    // Se o usuário autenticado não for estudante
    if (user.tipo !== 'estudante') {
      navigate('/unauthorized', { replace: true });
      return;
    }

  }, [user, loading, prestacaoId, navigate, location]);

  // Exibe loading enquanto verifica autenticação
  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  // Se houver erro de permissão
  if (user && user.tipo !== 'estudante') {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">
          Você não tem permissão para acessar esta página.
          Apenas estudantes podem visualizar faturas.
        </Alert>
      </Box>
    );
  }

  // Se usuário autenticado e é estudante, renderiza o componente filho
  return user && user.tipo === 'estudante' ? children : null;
};

StudentFaturaRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default StudentFaturaRoute;